import {ExperimentalFeatureKey} from '@/services/experimentalFeatures/features';
import {useUserFeatureFlags} from '@/services/experimentalFeatures/useUserFeatureFlags';

export function useUserFeatureFlag(featureKey: ExperimentalFeatureKey) {
    const {privateUserFeatureFlags, publicUserFeatureFlags} = useUserFeatureFlags();
    return {...privateUserFeatureFlags, ...publicUserFeatureFlags}[featureKey];
}
